import { Controller } from "@hotwired/stimulus"

// Drag-and-drop sortable list for match priority strategies.
// Each item can be toggled on/off via checkbox; DOM order = priority order.
// Hidden inputs are synced on every change so the form submits the correct array.
export default class extends Controller {
  static targets = ["item", "hiddenFields"]

  connect() {
    this.dragItem = null
  }

  dragstart(event) {
    this.dragItem = event.currentTarget
    event.currentTarget.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  dragend(event) {
    event.currentTarget.classList.remove("opacity-50")
    this.dragItem = null
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target === this.dragItem) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.dragItem, target)
    } else {
      target.parentNode.insertBefore(this.dragItem, target.nextSibling)
    }

    this.syncHiddenFields()
  }

  toggle() {
    this.syncHiddenFields()
  }

  syncHiddenFields() {
    const container = this.hiddenFieldsTarget
    container.innerHTML = ""

    this.itemTargets.forEach((item) => {
      const checkbox = item.querySelector("input[type='checkbox']")
      if (checkbox.checked) {
        const hidden = document.createElement("input")
        hidden.type = "hidden"
        hidden.name = "vendor[match_priority][]"
        hidden.value = checkbox.value
        container.appendChild(hidden)
      }
    })
  }
}